import React from 'react';
import {
  bool, func, string, arrayOf, exact, number, objectOf,
} from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import {
  Flex, Typography, Input, Checkbox,
} from '@atoms';
import { ImageUploader, SpecialSizesModal } from '@molecules';
import {
  DraggableItems, SpecialProcessModal, AvailabilityProcessModal, EntitySpecials,
} from '@organisms';
import { Edit } from '@templates';

const CategoryProcess = ({
  onEditConfirm,
  onSpecialWarningModalClose,
  isSpecialWarningModalOpen,
  onSpecialAvailabilityAdd,
  onSpecialAvailabilityDetach,
  specialAvailabilities,
  isSpecialConfirmButtonDisabled,
  onSpecialDelete,
  isSpecialDeleteModalOpen,
  onSpecialDeleteModalChangeState,
  onSpecialEditSubmit,
  onSpecialAdd,
  isSizesSpecialModalOpen,
  onSizesSpecialModalChangeState,
  onSelectedSizeSpecialChange,
  selectedSizeSpecial,
  categorySizes,
  isSpecialEditing,
  onSpecialEdit,
  categorySpecials,
  discountTypes,
  onSpecialModalChangeState,
  isSpecialModalOpen,
  selectedDiscountType,
  onDiscountTypeChange,
  onStartDateRemove,
  onEndDateRemove,
  onStartTimeRemove,
  onEndTimeRemove,
  onAvailabilityEdit,
  isAvailabilityConfirmButtonDisabled,
  onAvailabilityModalChangeState,
  isAvailabilityModalOpen,
  onAvailabilityDelete,
  onAvailabilityDeleteModalChangeState,
  onAvailabilityEditSubmit,
  isAvailabilityDeleteModalOpen,
  isAvailabilityEditing,
  startTime,
  endTime,
  startDate,
  endDate,
  onStartTimeChange,
  onEndTimeChange,
  onStartDateChange,
  onEndDateChange,
  onDayClick,
  selectedWeekDays,
  onAvailabilityNameChange,
  availabilityName,
  error,
  onAvailabilityAdd,
  availabilities,
  isCategoryActive,
  onCategoryActivityChange,
  onModalChangeState,
  isModalOpen,
  isEditing,
  isConfirmButtonDisabled,
  onCategoryDelete,
  onDragSubcategoryEnd,
  onDragItemEnd,
  subcategories,
  items,
  isLoading,
  categoryName,
  onToastClose,
  onCategoryNameChange,
  onEditSubmit,
  onEditCancel,
  hasServerError,
  image,
  onImageChange,
  onAvailabilityDetach,
  // onImageRemove
}) => (
  <Edit
    name={categoryName}
    onDelete={onCategoryDelete}
    isEditing={isEditing}
    onModalChangeState={onModalChangeState}
    isModalOpen={isModalOpen}
    isConfirmButtonDisabled={isConfirmButtonDisabled}
    isLoading={isLoading}
    onToastClose={onToastClose}
    onEditCancel={onEditCancel}
    onEditSubmit={onEditSubmit}
    hasServerError={hasServerError}
    error={error}
  >
    <Input
      marginTop="xl2"
      marginBottom="xl4"
      type="text"
      id="categoryName"
      name="categoryName"
      placeholder="Category name"
      value={categoryName}
      onChange={onCategoryNameChange}
      data-cy="categoryName"
    />
    <ImageUploader
      image={image}
      onImageChange={onImageChange}
      // onImageRemove={onImageRemove}
    />
    <Flex selfCenter itemsCenter marginTop="xl5">
      <Checkbox onCheckedStateChange={onCategoryActivityChange} isChecked={isCategoryActive} />
      <Typography marginLeft="lg" size="xl3" weight="black">Is category active?</Typography>
    </Flex>
    <Flex itemsCenter column paddingTop="xl5">
      {!!subcategories.length && (
        <>
          <Typography marginBottom="xl3" size="xl2" weight="black">
            Subcategories of current category
          </Typography>
          <DragDropContext onDragEnd={onDragSubcategoryEnd}>
            <Droppable droppableId="categorySubcategories">
              {provided => (
                <Flex column ref={provided.innerRef} {...provided.droppableProps}>
                  <DraggableItems items={subcategories} />
                  {provided.placeholder}
                </Flex>
              )}
            </Droppable>
          </DragDropContext>
        </>
      )}
      {!subcategories.length && (
        <>
          <Typography marginBottom="md" size="xl3" weight="black">
            Items of current category
          </Typography>
          {items.length
            ? (
              <DragDropContext onDragEnd={onDragItemEnd}>
                <Droppable droppableId="categorySubcategories">
                  {provided => (
                    <Flex column ref={provided.innerRef} {...provided.droppableProps}>
                      <DraggableItems items={items} />
                      {provided.placeholder}
                    </Flex>
                  )}
                </Droppable>
              </DragDropContext>
            )
            : (
              <Flex justifyStart>
                <Typography size="lg" color="warmGrey" weight="black" marginBottom="lg">
                  Nothing here yet
                </Typography>
              </Flex>
            )}
        </>
      )}
      <SpecialProcessModal
        onEditConfirm={onEditConfirm}
        onSpecialWarningModalClose={onSpecialWarningModalClose}
        isSpecialWarningModalOpen={isSpecialWarningModalOpen}
        onAvailabilityModalChangeState={onAvailabilityModalChangeState}
        onAvailabilityDetach={onSpecialAvailabilityDetach}
        availabilities={specialAvailabilities}
        onAvailabilityEdit={onAvailabilityEdit}
        onAvailabilityAdd={onSpecialAvailabilityAdd}
        onStartDateRemove={onStartDateRemove}
        onEndDateRemove={onEndDateRemove}
        onStartTimeRemove={onStartTimeRemove}
        onEndTimeRemove={onEndTimeRemove}
        isAvailabilityConfirmButtonDisabled={isAvailabilityConfirmButtonDisabled}
        onAvailabilityDeleteModalChangeState={onAvailabilityDeleteModalChangeState}
        startTime={startTime}
        endTime={endTime}
        startDate={startDate}
        endDate={endDate}
        onStartTimeChange={onStartTimeChange}
        onEndTimeChange={onEndTimeChange}
        onStartDateChange={onStartDateChange}
        onEndDateChange={onEndDateChange}
        onAvailabilityNameChange={onAvailabilityNameChange}
        onAvailabilityEditSubmit={onAvailabilityEditSubmit}
        availabilityName={availabilityName}
        isAvailabilityModalOpen={isAvailabilityModalOpen}
        onAvailabilityModalClose={onAvailabilityModalChangeState}
        isAvailabilityDeleteModalOpen={isAvailabilityDeleteModalOpen}
        onAvailabilityDelete={onAvailabilityDelete}
        onDayClick={onDayClick}
        selectedWeekDays={selectedWeekDays}
        isConfirmButtonDisabled={isSpecialConfirmButtonDisabled}
        onSpecialEditSubmit={onSpecialEditSubmit}
        onSelectedEntityChange={onSelectedSizeSpecialChange}
        entities={categorySizes}
        selectedEntity={selectedSizeSpecial}
        isEditing={isSpecialEditing}
        discountTypes={discountTypes}
        onSpecialDelete={onSpecialDelete}
        isSpecialDeleteModalOpen={isSpecialDeleteModalOpen}
        onSpecialDeleteModalChangeState={onSpecialDeleteModalChangeState}
        selectedDiscountType={selectedDiscountType}
        onDiscountTypeChange={onDiscountTypeChange}
        isModalOpen={isSpecialModalOpen}
        onModalClose={onSpecialModalChangeState}
      />
      <SpecialSizesModal
        onSizeSelect={onSelectedSizeSpecialChange}
        onModalClose={onSizesSpecialModalChangeState}
        isModalOpen={isSizesSpecialModalOpen}
        sizes={categorySizes}
      />
      {isEditing && (
        <>
          <>
            <Typography marginBottom="md" marginTop="xl5" size="xl3" weight="black">
              Availability periods of category
            </Typography>
            <DragDropContext>
              <Droppable droppableId="categoryAvailabilities">
                {provided => (
                  <Flex column ref={provided.innerRef} {...provided.droppableProps}>
                    <DraggableItems
                      onItemClick={onAvailabilityEdit}
                      onItemRemove={onAvailabilityDetach}
                      onItemAdd={onAvailabilityAdd}
                      isDraggable={false}
                      canBeAdded={isEditing}
                      items={availabilities}
                    />
                    {provided.placeholder}
                  </Flex>
                )}
              </Droppable>
            </DragDropContext>
          </>
          <EntitySpecials
            onSpecialEdit={onSpecialEdit}
            onSpecialAdd={onSpecialAdd}
            specials={categorySpecials}
          />
        </>
      )}
    </Flex>
    <AvailabilityProcessModal
      onStartDateRemove={onStartDateRemove}
      onEndDateRemove={onEndDateRemove}
      onStartTimeRemove={onStartTimeRemove}
      onEndTimeRemove={onEndTimeRemove}
      isConfirmButtonDisabled={isAvailabilityConfirmButtonDisabled}
      onAvailabilityDeleteModalChangeState={onAvailabilityDeleteModalChangeState}
      startTime={startTime}
      endTime={endTime}
      startDate={startDate}
      endDate={endDate}
      onStartTimeChange={onStartTimeChange}
      onEndTimeChange={onEndTimeChange}
      onStartDateChange={onStartDateChange}
      onEndDateChange={onEndDateChange}
      onAvailabilityNameChange={onAvailabilityNameChange}
      isEditing={isAvailabilityEditing}
      onAvailabilityEditSubmit={onAvailabilityEditSubmit}
      availabilityName={availabilityName}
      isModalOpen={isAvailabilityModalOpen}
      onModalClose={onAvailabilityModalChangeState}
      isAvailabilityDeleteModalOpen={isAvailabilityDeleteModalOpen}
      onAvailabilityDelete={onAvailabilityDelete}
      onDayClick={onDayClick}
      selectedWeekDays={selectedWeekDays}
    />
  </Edit>
);

CategoryProcess.defaultProps = {
  selectedSizeSpecial: null,
  error: '',
  image: '',
  categorySpecials: [],
};

CategoryProcess.propTypes = {
  onEditConfirm: func.isRequired,
  onSpecialWarningModalClose: func.isRequired,
  isSpecialWarningModalOpen: bool.isRequired,
  onSpecialAvailabilityAdd: func.isRequired,
  specialAvailabilities: arrayOf(exact({
    name: string,
    id: number,
  })).isRequired,
  error: string,
  onSpecialAvailabilityDetach: func.isRequired,
  isSpecialConfirmButtonDisabled: bool.isRequired,
  onSpecialDelete: func.isRequired,
  isSpecialDeleteModalOpen: bool.isRequired,
  onSpecialDeleteModalChangeState: func.isRequired,
  onSpecialEditSubmit: func.isRequired,
  onSpecialAdd: func.isRequired,
  isSizesSpecialModalOpen: bool.isRequired,
  onSizesSpecialModalChangeState: func.isRequired,
  onSelectedSizeSpecialChange: func.isRequired,
  selectedSizeSpecial: number,
  categorySizes: arrayOf(exact({
    id: number,
    name: string,
    price: number,
  })).isRequired,
  isSpecialEditing: bool.isRequired,
  onSpecialEdit: func.isRequired,
  categorySpecials: arrayOf(exact({
    id: number,
    categoryId: number,
    available: bool,
    availabilityIds: arrayOf(number),
    sizeName: string,
    discountType: string,
    discountValue: number,
  })),
  onSpecialModalChangeState: func.isRequired,
  isSpecialModalOpen: bool.isRequired,
  selectedDiscountType: string.isRequired,
  onDiscountTypeChange: func.isRequired,
  discountTypes: objectOf(exact({
    name: string,
    inputValue: string,
    inputHandler: func,
  })).isRequired,
  onStartDateRemove: func.isRequired,
  onEndDateRemove: func.isRequired,
  onStartTimeRemove: func.isRequired,
  onEndTimeRemove: func.isRequired,
  onAvailabilityEdit: func.isRequired,
  isAvailabilityConfirmButtonDisabled: bool.isRequired,
  onAvailabilityModalChangeState: func.isRequired,
  isAvailabilityModalOpen: bool.isRequired,
  onAvailabilityDelete: func.isRequired,
  onAvailabilityDeleteModalChangeState: func.isRequired,
  onAvailabilityEditSubmit: func.isRequired,
  isAvailabilityDeleteModalOpen: bool.isRequired,
  isAvailabilityEditing: bool.isRequired,
  startTime: string.isRequired,
  endTime: string.isRequired,
  startDate: string.isRequired,
  endDate: string.isRequired,
  onStartTimeChange: func.isRequired,
  onEndTimeChange: func.isRequired,
  onStartDateChange: func.isRequired,
  onEndDateChange: func.isRequired,
  onDayClick: func.isRequired,
  selectedWeekDays: arrayOf(number).isRequired,
  onAvailabilityNameChange: func.isRequired,
  availabilityName: string.isRequired,
  onAvailabilityDetach: func.isRequired,
  onAvailabilityAdd: func.isRequired,
  availabilities: arrayOf(exact({
    name: string,
    id: number,
  })).isRequired,
  isCategoryActive: bool.isRequired,
  onCategoryActivityChange: func.isRequired,
  isModalOpen: bool.isRequired,
  onModalChangeState: func.isRequired,
  isEditing: bool.isRequired,
  isConfirmButtonDisabled: bool.isRequired,
  onCategoryDelete: func.isRequired,
  // onImageRemove: func.isRequired,
  onDragItemEnd: func.isRequired,
  onDragSubcategoryEnd: func.isRequired,
  image: string,
  onImageChange: func.isRequired,
  items: arrayOf(exact({
    name: string,
    id: number,
  })).isRequired,
  subcategories: arrayOf(exact({
    name: string,
    id: number,
  })).isRequired,
  onToastClose: func.isRequired,
  hasServerError: bool.isRequired,
  isLoading: bool.isRequired,
  categoryName: string.isRequired,
  onCategoryNameChange: func.isRequired,
  onEditSubmit: func.isRequired,
  onEditCancel: func.isRequired,
};

export default CategoryProcess;
